import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    autoplay: { type: Boolean, default: true },
    pauseWhenHidden: { type: Boolean, default: true },
  };

  connect() {
    this.__observer = new IntersectionObserver(this.__handleIntersection, { threshold: 0.1 });
    this.__observer.observe(this.element);
  }

  disconnect() {
    this.__observer?.disconnect();
  }

  __handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && this.autoplayValue) {
        this.element.play().catch((error) => console.warn('Video autoplay failed:', error)); // eslint-disable-line no-console
      } else if (!entry.isIntersecting && this.pauseWhenHiddenValue) {
        this.element.pause();
      }
    });
  };
}
